<template>
  <v-card class="mx-auto">
    <v-card-title>Referred From Another Health Care Institution(HCI)</v-card-title>
    <v-card-text>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row>
          <v-col>
            <v-checkbox
              label="Yes"
              v-model="formData.referred_hci.is_referred"
              :true-value="'Y'"
              :false-value="'N'"
              hide-details
              @change="onReferredChange"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="4">
            <v-textarea
              v-model="formData.referred_hci.reason"
              :disabled="formData.referred_hci.is_referred === 'N'"
              outlined
              rows="1"
              auto-grow
              label="Specify Reason"
            />
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-textarea
              v-model="formData.referred_hci.originating_hci"
              :disabled="formData.referred_hci.is_referred === 'N'"
              outlined
              rows="1"
              auto-grow
              label="Name Of Originating HCI"
            />
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        :disabled="currentTab === 0"
        @click="backTab"
        color="info"
        class="mr-4">
        BACK
      </v-btn>
      <v-btn
        :disabled="!formData.referred_hci.reason && !formData.referred_hci.originating_hci"
        @click="validate"
        color="success"
        class="mr-4">
        NEXT
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
    export default {
        props: {
            currentTab: Number,
            formData: {
                required: true,
                type: Object
            }
        },

        data() {
            return {
                modal: false,
                valid: false,
            }
        },

        methods: {
            validate() {
                if (this.$refs.form.validate()) {
                    this.snackbar = true;
                    this.$bus.emit('nextTab', this.currentTab + 1);
                }
            },
            reset() {
                this.$refs.form.reset()
            },
            backTab() {
                this.$bus.emit('nextTab', this.currentTab - 1);
            },
            onReferredChange() {
                if (this.formData.referred_hci.is_referred === 'N') {
                    this.formData.referred_hci.reason = '';
                    this.formData.referred_hci.originating_hci = '';
                }
            }
        },
    }
</script>

<style scoped>

</style>